<div>
        <div class="modal-header">
            <h4 class="modal-title">Alert</h4>
            <button type="button" class="close" aria-label="Close" (click)="('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <p>Deleting this dashboard will remove the dashboard for other user as well. Do you still want to delete this? </p>
        </div>
        <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="Close()">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="confirmDelete()">Yes</button>
        </div>
</div>